export const GAME_TITLE = process.env.REACT_APP_GAME_NAME!
export const REDIRECT_URL = process.env.REACT_APP_REDIRECT_URL!

export const MAX_CODE_LENGTH = 5
export const MAX_CHALLENGES = 6
export const ALERT_TIME_MS = 2000
export const REVEAL_TIME_MS = 350
export const GAME_LOST_INFO_DELAY = (MAX_CODE_LENGTH + 1) * REVEAL_TIME_MS
export const WELCOME_INFO_MODAL_MS = 350
